/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Coklu_KullaniciInputs */

const tr_faq_q_coklu_kullanici = /** @type {(inputs: Faq_Q_Coklu_KullaniciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Birden fazla kullanıcı eklenebilir mi?`)
};

const en_faq_q_coklu_kullanici = /** @type {(inputs: Faq_Q_Coklu_KullaniciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I add multiple team members?`)
};

const de_faq_q_coklu_kullanici = /** @type {(inputs: Faq_Q_Coklu_KullaniciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich mehrere Teammitglieder hinzufügen?`)
};

const ru_faq_q_coklu_kullanici = /** @type {(inputs: Faq_Q_Coklu_KullaniciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Можно ли добавить несколько участников команды?`)
};

/**
* | output |
* | --- |
* | "Can I add multiple team members?" |
*
* @param {Faq_Q_Coklu_KullaniciInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_coklu_kullanici = /** @type {((inputs?: Faq_Q_Coklu_KullaniciInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Coklu_KullaniciInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_coklu_kullanici(inputs)
	if (locale === "de") return de_faq_q_coklu_kullanici(inputs)
	if (locale === "ru") return ru_faq_q_coklu_kullanici(inputs)
	return tr_faq_q_coklu_kullanici(inputs)
});